export default "__VITE_ASSET__abb250dd__"